import { connect } from "react-redux";
import get from "lodash/get";

import {
  logisticSearchTerm as onLogisticSearchTerm,
  setLogisticGroups as onSetLogisticGroups,
} from "../../actions/logosticFilterActions";

const mapStateToProps = (state) => ({
  searchTerm: get(state, ["logosticFilter", "searchTerm"], null),
  logisticGroupsFilter: get(state, ["logosticFilter", "logisticGroupsFilter"], []),
});

const mapDispatchToProps = { onLogisticSearchTerm, onSetLogisticGroups };

const withLogosticFilter = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withLogosticFilter };
